module.exports = __webpack_public_path__ + "app/principal/invoice-statements/invoice-statements-1lcNLB2c.html";